module.exports = __webpack_public_path__ + "static/media/pattern7.fe14d104.svg";